import { useAdvancedSettings } from '@/hooks/application/useAdvancedSettings';
import { logError } from '@/utils/usefulFuncs';
import React from 'react';

const defaultState = {
  values: {},
  isModalVisible: false,

  showAdvancedSettingsModal: () => {
    logError('showAdvancedSettingsModal not initialized');
  },
  hideAdvancedSettingsModal: () => {
    logError('hideAdvancedSettingsModal not initialized');
  },
};

export const AdvancedSettingsContext = React.createContext(defaultState);

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_VALUES': {
      return { ...state, values: action.payload };
    }
    case 'SHOW_ADVANCED_SETTINGS_MODAL': {
      return { ...state, isModalVisible: true };
    }
    case 'HIDE_ADVANCED_SETTINGS_MODAL': {
      return { ...state, isModalVisible: false };
    }
    case 'INIT': {
      return { ...state, ...action.payload };
    }
    case 'RESET': {
      return { ...state, values: defaultState.values, isModalVisible: false };
    }
    default: {
      return state;
    }
  }
};

export const AdvancedSettingsProvider = ({ children }) => {
  const advancedSettingsValues = useAdvancedSettings();
  return <AdvancedSettingsContext.Provider value={advancedSettingsValues}>{children}</AdvancedSettingsContext.Provider>;
};
